import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { payoutTargetIdZodSchema } from "@@/shared/financials/payout-targets/payout-target-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { customFeeRequestZodObject } from "./settlements/custom-fee-request";
import { hardCodedFeeIdZodEnum } from "./settlements/hard-coded-fees";

const createSettlementNote_providerFormZodObject = z.object({
    _type: z.literal("CREATE_SETTLEMENT_NOTE__PROVIDER_FORM"),
    providerId: providerIdZodSchema,
    payoutTargetId: payoutTargetIdZodSchema,
    start: isoAndUnixZodSchema,
    end: isoAndUnixZodSchema,
    serialNumber: z.string(),
    fees: z.array(z.union([hardCodedFeeIdZodEnum, customFeeRequestZodObject])),
    settlementDate: isoAndUnixZodSchema,
    selected: z.boolean(),
});
type CreateSettlementNote_ProviderForm = z.infer<
    typeof createSettlementNote_providerFormZodObject
>;

type FactoryParams = Except<CreateSettlementNote_ProviderForm, "_type">;

const createSettlementNote_providerFormFactory = (
    params: FactoryParams,
): CreateSettlementNote_ProviderForm => {
    return {
        ...params,
        _type: "CREATE_SETTLEMENT_NOTE__PROVIDER_FORM",
    };
};

export {
    createSettlementNote_providerFormFactory,
    createSettlementNote_providerFormZodObject,
};
export type { CreateSettlementNote_ProviderForm };
